export const toastState = {
    toasts: [],
};
